import { createRouter, createWebHistory } from 'vue-router';
// import store from '@/store'; // Vuexストアをインポート
import LoginPage from '@/components/LoginPage';
import DashboardPage from '@/components/DashboardPage';
import RegistrationComplete from '@/components/RegistrationComplete';
import VideoManagement from '@/components/VideoManagement';
import ArticleManagement from '@/components/ArticleManagement';
import ChannelManagement from '@/components/ChannelManagement';
import ArticleSettings from '@/components/ArticleSettings';
import ArticlePreview from '@/components/ArticlePreview';
import ChannelCreation from '@/components/ChannelCreation';
import ChannelCreated from '@/components/ChannelCreated';
import ChannelInvitation from '@/components/ChannelInvitation';
import AccountCreation from '@/components/AccountCreation';
import AccountCreated from '@/components/AccountCreated';
import UserGuideline from '@/components/UserGuideline';
import Information from '@/components/InformationTable';
import InformationDetails from '@/components/InformationDetails';
import MemberManagement from '@/components/MemberManagement';
import { isLogin } from '../composables/userCheckAuth'
import { isGuideline } from '../composables/userCheckGuideline'

const routes = [
  {
      path:'/',
      name:'Dashboard',
      component: DashboardPage,
      meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage, //ログインページのため、非ログイン時の制御はしない。
  },
  {
    path: '/registration-complete',
    name: 'RegistrationComplete',
    component: RegistrationComplete,
    meta: { requiresAuth: true }
  },
  {
    path: '/video-management',
    name:'VideoManagement',
    component: VideoManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/article-management',
    name:'ArticleManagement',
    component: ArticleManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-management',
    name:'ChannelManagement',
    component: ChannelManagement,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles/settings/:id',
    name: 'ArticleSettings',
    component: ArticleSettings,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles/settings/:id/preview',
    name:'ArticlePreview',
    component: ArticlePreview,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-creation',
    name: 'ChannelCreation',
    component: ChannelCreation,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-created',
    name: 'ChannelCreated',
    component: ChannelCreated,
    meta: { requiresAuth: true }
  },
  {
    path: '/channel-invitation',
    name: 'ChannelInvitation',
    component: ChannelInvitation,
    meta: { requiresAuth: true }
  },
  {
    path: '/account-creation',
    name: 'AccountCreation',
    component: AccountCreation,
  },
  {
    path: '/account-created',
    name: 'AccountCreated',
    component: AccountCreated,
    meta: { requiresAuth: true }
  },
  {
    path: '/guideline',
    name: 'UserGuideline',
    component: UserGuideline
  },
  {
    path: '/information',
    name: 'Information',
    component: Information,
    meta: { requiresAuth: true }
  },
  {
    path: '/information/details/:id/',
    name:'InformationDetails',
    component: InformationDetails,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/member-management',
    name: 'MemberManagement',
    component: MemberManagement,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*', // すべての未定義のパスにマッチする
    name: 'NotFound',
    component: () => import('@/components/NotFound.vue'), // 遅延ロード
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLogin()) {
      next({ path: '/login' });
    } 
    if (!isGuideline()) {
      if (to.name !== 'VideoManagement') {
        next ({ path: '/video-management' });
      }
    }
    next();
  } else {
    next();
  }
});

export default router;
